module.exports = __webpack_public_path__ + "media/images/demo/vertical-default-cc73e1310a3b4c9d6331241ecf77953b.jpg";